/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateCriticalNotificationDto,
    CreateCriticalNotificationDtoFromJSON,
    CreateCriticalNotificationDtoToJSON,
    CriticalNotificationDto,
    CriticalNotificationDtoFromJSON,
    CriticalNotificationDtoToJSON,
    UpdateCriticalNotificationDto,
    UpdateCriticalNotificationDtoFromJSON,
    UpdateCriticalNotificationDtoToJSON,
} from '../models';

export interface CriticalNotificationAdminControllerCreateRequest {
    createCriticalNotificationDto: CreateCriticalNotificationDto;
}

export interface CriticalNotificationAdminControllerDeleteRequest {
    id: string;
}

export interface CriticalNotificationAdminControllerUpdateRequest {
    id: string;
    updateCriticalNotificationDto: UpdateCriticalNotificationDto;
}

/**
 * 
 */
export class AdminCriticalNotificationsApi extends runtime.BaseAPI {

    /**
     * Create critical notification
     */
    async criticalNotificationAdminControllerCreateRaw(requestParameters: CriticalNotificationAdminControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CriticalNotificationDto>> {
        if (requestParameters.createCriticalNotificationDto === null || requestParameters.createCriticalNotificationDto === undefined) {
            throw new runtime.RequiredError('createCriticalNotificationDto','Required parameter requestParameters.createCriticalNotificationDto was null or undefined when calling criticalNotificationAdminControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/critical-notifications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCriticalNotificationDtoToJSON(requestParameters.createCriticalNotificationDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CriticalNotificationDtoFromJSON(jsonValue));
    }

    /**
     * Create critical notification
     */
    async criticalNotificationAdminControllerCreate(requestParameters: CriticalNotificationAdminControllerCreateRequest, initOverrides?: RequestInit): Promise<CriticalNotificationDto> {
        const response = await this.criticalNotificationAdminControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete critical notification
     */
    async criticalNotificationAdminControllerDeleteRaw(requestParameters: CriticalNotificationAdminControllerDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling criticalNotificationAdminControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/critical-notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete critical notification
     */
    async criticalNotificationAdminControllerDelete(requestParameters: CriticalNotificationAdminControllerDeleteRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.criticalNotificationAdminControllerDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all critical notifications for admin
     */
    async criticalNotificationAdminControllerGetAdminListRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CriticalNotificationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/critical-notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CriticalNotificationDtoFromJSON));
    }

    /**
     * Get all critical notifications for admin
     */
    async criticalNotificationAdminControllerGetAdminList(initOverrides?: RequestInit): Promise<Array<CriticalNotificationDto>> {
        const response = await this.criticalNotificationAdminControllerGetAdminListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update critical notification
     */
    async criticalNotificationAdminControllerUpdateRaw(requestParameters: CriticalNotificationAdminControllerUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CriticalNotificationDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling criticalNotificationAdminControllerUpdate.');
        }

        if (requestParameters.updateCriticalNotificationDto === null || requestParameters.updateCriticalNotificationDto === undefined) {
            throw new runtime.RequiredError('updateCriticalNotificationDto','Required parameter requestParameters.updateCriticalNotificationDto was null or undefined when calling criticalNotificationAdminControllerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/critical-notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCriticalNotificationDtoToJSON(requestParameters.updateCriticalNotificationDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CriticalNotificationDtoFromJSON(jsonValue));
    }

    /**
     * Update critical notification
     */
    async criticalNotificationAdminControllerUpdate(requestParameters: CriticalNotificationAdminControllerUpdateRequest, initOverrides?: RequestInit): Promise<CriticalNotificationDto> {
        const response = await this.criticalNotificationAdminControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
